import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { MdcCircularProgress, MdcBox, MdcTypography } from 'ids-wc/dist/react/components';
import React, { ReactNode, Suspense } from 'react';
import { ErrorBoundary } from './ErrorBoundary.tsx';

interface Props {
  children: ReactNode;
}

export const SuspenseWithErrorBoundary: React.FC<Props> = ({ children }) => {
  const { t } = useTranslationHelper('common');

  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <MdcBox display="flex" direction="column" justifyContent="center" alignItems="center" className="h-100 mt-5">
            <MdcCircularProgress color="primary" className="mb-2" indeterminate size="lg" labelAria="loading" />
            <MdcTypography text={t('pleaseWait')} variant="subtitle1" />
          </MdcBox>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};
